import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { I18n } from '@app/i18n/strings-keys';
import { TokenSessionService } from '@app/shared/services';
import { get } from 'lodash';
@Component({
  selector: 'xea-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ErrorComponent implements OnInit {
  public readonly errorTitle = I18n.ErrorStrings.Error;
  public defaultMessage = I18n.ErrorStrings.IncorrectUrl;
  public message: string = this.defaultMessage;

  public constructor(
    private router: Router,
    private tokenSessionService: TokenSessionService,
  ) {
    this.tokenSessionService.removeAll();

    this.message = get(
      this.router.getCurrentNavigation().extras.state,
      'message',
      this.defaultMessage,
    );
  }
  public ngOnInit() {}
}
